import { localizedDateFormat } from '../utils/dateFormatters'

export default {
  methods: {
    publicationDate: (value, format = 'DD MMMM YYYY') => {
      return localizedDateFormat(value, format)
    }
  }
}
